module.exports = __webpack_public_path__ + "sy.svg?96bb3c224fd1a7a3f7869ca176b6ce54";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/sy.svg
// module id = 1633
// module chunks = 0